<template>
  <div>
    <div class="flex justify-between px-5 py-3">
      <JadeDisplayItem
        :label="$t('amount')"
        :value="data.value"
        :support="data.id"
      />
      <JadeDisplayItem
        alignment="right"
        :label="$t('status')"
        :value="data.status"
      />
    </div>
    <JadeDivider size="medium" />
  </div>
</template>

<script>
import { JadeDisplayItem, JadeDivider } from '@jade'

export default {
  name: 'LayoutDataAcquirer',

  components: {
    JadeDisplayItem,
    JadeDivider
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "amount": "Valor",
      "status": "Situação"
    },
    "en-US": {
      "amount": "Amount",
      "status": "Status"
    }
  }
</i18n>
